import axios from 'axios'
import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'
const {
  roles,
} = config.endpoints

const getRoles = () => axios.get(roles.roles, { headers: getHeaders(true) })

const getInfoRoles = () => axios.get(roles.infoRoles, { headers: getHeaders(true) })

const getPermissionListRoles = () => axios({
  url: roles.rolesPermissionsList,
  method: 'post',
  headers: getHeaders(true)
})

/**
 *
 * @param {Object} data
 * @param {String} data.resource
 * @param {Boolean} data.resourceValue
 * @param {String} data.role
 * @returns
 */
const updatePermissionList = (data) => axios({
  url: roles.rolesPermissionsUpdate,
  method: 'post',
  data,
  headers: getHeaders(true)
})

const getOperatorPermissions = () => axios({
  url: roles.operatorPermissions,
  method: 'get',
  headers: getHeaders(true)
})

export default {
  getRoles,
  getInfoRoles,
  getPermissionListRoles,
  updatePermissionList,
  getOperatorPermissions
}
